module.exports = __webpack_public_path__ + "static/loader-fdb20cce2c67929fd3c3a52f7c0b2dbb.gif";